

export default class API {

    static url =process.env.REACT_APP_GRAPHQL_API_URL;
    static xAuthToken = process.env.REACT_APP_X_AUTH_TOKEN;
}


